import React from "react";
import { NavLink } from "react-router-dom";
import IpsTable from "./components/IpsTable";

const index = () => {
  return (
    <>
      <IpsTable />
    </>
  );
};

export default index;
